import { dayjs } from "@outschool/time";
import { useEffect, useState } from "react";

const MINUTE = 60 * 1000;

export const useLiveFromNow = (startTime: string) => {
  const [fromNow, setFromNow] = useState(() => dayjs(startTime).fromNow());

  useEffect(() => {
    const updateFromNow = () => {
      setFromNow(dayjs(startTime).fromNow());
    };

    updateFromNow();

    const interval = setInterval(updateFromNow, MINUTE);

    return () => {
      clearInterval(interval);
    };
  }, [startTime]);

  return fromNow;
};
